import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { UserContext } from '@app/providers';

const containerStyle = {
  height: '100%',
  width: '100%',
  position: 'relative',
  transition: '.1s filter linear',
  paddingTop: 0,
};

const BlurScreen = ({ children, containerStyle: customStyle, isBlurShown }) => {
  const { isAutoLogoutDialogOpen } = useSelector(state => state.appSettings);
  const { changeAccountLoading } = useContext(UserContext);

  return (
    <div
      style={{
        ...containerStyle,
        ...customStyle,
        filter: isBlurShown || isAutoLogoutDialogOpen || changeAccountLoading ? 'blur(5px)' : null,
      }}
    >
      {children}
    </div>
  );
};

export default BlurScreen;
